import {BaseWidget} from "./BaseWidget";
import * as Formats from '../constants/Formats'

import moment from 'moment'

export class DateFieldWidget extends BaseWidget {
    afterAttach() {
        super.afterAttach();
        let that = this;
        that.datePicker = that.findElement().kendoDatePicker({
            format: Formats.DATE_FORMAT,
            parseFormats: Formats.DATE_PARSE_FORMAT,
            change: (e) => that.onEdit(that.readValueFromElement())
        }).data("kendoDatePicker");
        that.findElement().on("focus",(e)=>{this.datePicker.open()})
    }

    createElement(style) {
        return $(`<input class="w-100" type='text' ${style} id="${this.elementId}" nid="${this.id}">`);
    }
    setValueInElement(value) {
        this.datePicker.value(value || null);
    }

    readValueFromElement() {
        let val = this.datePicker.value();
        if (!val)
            return null;
        let date = new moment(val, Formats.DATE_MOMENT_SERVER_FORMAT);
        let format = date.format(Formats.DATE_MOMENT_SERVER_FORMAT);
        return format;
    }

    setEnabled(enabled) {
        this.datePicker.enable(enabled);
    }
}